export const HostLink = 'https://deenbook.co.uk:3000';
// export const HostLink = 'http://localhost:3000';

// http://localhost:3000
// https://deenbook.co.uk:3000

